const Ingredients = () => import("../ingredients/views/Ingredients.vue");
const IngredientEdit = () => import("../ingredients/views/IngredientEdit.vue");
const IngredientsImport = () => import("../ingredients/views/IngredientsImport.vue");
const PurchaseReport = () => import("../ingredients/views/PurchaseReport.vue");
const FoodCostReport = () => import("../ingredients/views/FoodCostReport.vue");
const ProductionReport = () => import("../ingredients/views/ProductionReport.vue");

const route = "/inventory/ingredients";

export default [
  {
    path: route,
    name: "inventory.ingredients.list",
    component: Ingredients,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "inventory.ingredients.create",
    component: IngredientEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:ingredientId/edit`,
    name: "inventory.ingredients.edit",
    component: IngredientEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/import`,
    name: "inventory.ingredients.import",
    component: IngredientsImport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/purchaseReport",
    name: "inventory.ingredients.purchaseReport",
    component: PurchaseReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: "/foodCostReport",
    name: "inventory.ingredients.foodCostReport",
    component: FoodCostReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },

  {
    path: "/productionReport",
    name: "inventory.ingredients.productionReport",
    component: ProductionReport,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_COOK"],
    },
  },
];
